import { useEffect, useState } from "react";

export const MOBILE_QUERY = "(max-width: 768px)";

// Tracks a media query live so layout decisions survive rotation and resizing,
// rather than reading window.innerWidth once at render like the older screens do.
export const useIsMobile = (query = MOBILE_QUERY) => {
    const [matches, setMatches] = useState(() => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia(query).matches : false));

    useEffect(() => {
        if (typeof window === "undefined" || !window.matchMedia) return undefined;
        const mql = window.matchMedia(query);
        const onChange = (e) => setMatches(e.matches);
        setMatches(mql.matches);

        // Safari below 14 only has the deprecated addListener API.
        if (mql.addEventListener) mql.addEventListener("change", onChange);
        else mql.addListener(onChange);

        return () => {
            if (mql.removeEventListener) mql.removeEventListener("change", onChange);
            else mql.removeListener(onChange);
        };
    }, [query]);

    return matches;
};

export default useIsMobile;
